import styled from "styled-components";

export const Card2Style = styled.div`
  .card-container {
    box-shadow: 0 0 15px rgba(247, 148, 29, 0.3);
    transition: box-shadow 0.3s ease;
    border-radius: 8px;
    border: 1px solid white;
    padding: 1.3vh 1.5vh;
    text-align: center;
    justify-content: center;
    display: flex;
    flex-direction: column;
    width: 30vh;
    height: 14vh;
    margin-bottom: 5vh;
    overflow-wrap: anywhere;
    font-family: medium-pro, sans-serif;
    margin-right: 5vh;
    justify-content: space-between;
    :hover {
      box-shadow: 0 15px 24px rgba(247, 148, 29, 0.3);
    }
  }
  .heading {
    font-size: 1.5vh;
    align-self: center;
    color: #5e5d5c;
  }
  .total {
    font-size: 2vh;
    font-weight: bold;
    align-self: center;
  }

  /* For medium devices */
  @media screen and (max-width: 576px) {
    .card-container {
      margin-right: 0;
    }
  }
`;
